import React from 'react'

export const Hero = () => {
  return (
    <main>
        <h1 className='text-[3.5em] font-bold w-5/6 mx-auto text-center leading-tight mb-5'>Streamline your viewing experience</h1>
        <p className='w-5/6 mx-auto text-lg text-slate-300 mb-5'>Find movies across streaming platforms effortlessly.</p>
    </main>
  )
}
